var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoryGridGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 4.33334V47.6667",
    stroke: "#5DEE7A",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 26H51.6667",
    stroke: "#5DEE7A",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 4.33334H8.33337V47.6667H51.6667V4.33334Z",
    stroke: "#5DEE7A",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4743 20.3125H14.1239L18.0294 9.67615H19.359L23.2645 20.3125H21.9142L18.7358 11.3588H18.6527L15.4743 20.3125ZM15.9728 16.1577H21.4157V17.3002H15.9728V16.1577Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9755 20.3125V9.67615H40.694C41.435 9.67615 42.0461 9.80428 42.5274 10.0605C43.0087 10.3132 43.367 10.6542 43.6025 11.0836C43.8379 11.5095 43.9556 11.9821 43.9556 12.5015C43.9556 12.9585 43.8742 13.3359 43.7115 13.6336C43.5522 13.9314 43.341 14.1668 43.0779 14.3399C42.8182 14.513 42.5361 14.6412 42.2314 14.7243V14.8281C42.5568 14.8489 42.884 14.9632 43.2129 15.1709C43.5418 15.3787 43.8171 15.6764 44.0387 16.0642C44.2603 16.452 44.3711 16.9263 44.3711 17.4872C44.3711 18.0204 44.2499 18.5 44.0076 18.9258C43.7652 19.3517 43.3826 19.6893 42.8598 19.9386C42.3369 20.1879 41.6566 20.3125 40.8187 20.3125H36.9755ZM38.2635 19.17H40.8187C41.6601 19.17 42.2573 19.0072 42.6105 18.6817C42.9671 18.3528 43.1454 17.9546 43.1454 17.4872C43.1454 17.1271 43.0537 16.7948 42.8701 16.4901C42.6866 16.1819 42.4252 15.9361 42.0859 15.7526C41.7466 15.5656 41.345 15.4721 40.881 15.4721H38.2635V19.17ZM38.2635 14.3503H40.6525C41.0403 14.3503 41.39 14.2742 41.7016 14.1218C42.0167 13.9695 42.266 13.7548 42.4494 13.4778C42.6365 13.2009 42.7299 12.8754 42.7299 12.5015C42.7299 12.034 42.5672 11.6376 42.2418 11.3121C41.9163 10.9832 41.4004 10.8187 40.694 10.8187H38.2635V14.3503Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5969 34.125H22.309C22.2328 33.7545 22.0995 33.4291 21.9091 33.1486C21.7221 32.8681 21.4935 32.6328 21.2236 32.4423C20.9569 32.2484 20.6609 32.103 20.3354 32.006C20.0099 31.9091 19.6706 31.8606 19.3175 31.8606C18.6735 31.8606 18.0901 32.0234 17.5673 32.3488C17.0479 32.6743 16.6341 33.1538 16.326 33.7874C16.0214 34.421 15.869 35.1983 15.869 36.1193C15.869 37.0403 16.0214 37.8176 16.326 38.4512C16.6341 39.0848 17.0479 39.5644 17.5673 39.8898C18.0901 40.2153 18.6735 40.378 19.3175 40.378C19.6706 40.378 20.0099 40.3296 20.3354 40.2326C20.6609 40.1356 20.9569 39.992 21.2236 39.8015C21.4935 39.6077 21.7221 39.3705 21.9091 39.09C22.0995 38.8061 22.2328 38.4806 22.309 38.1136H23.5969C23.5 38.6572 23.3235 39.1436 23.0672 39.5731C22.811 40.0024 22.4924 40.3676 22.1116 40.6689C21.7307 40.9667 21.3032 41.1934 20.8288 41.3492C20.3579 41.505 19.8542 41.5829 19.3175 41.5829C18.4104 41.5829 17.6036 41.3613 16.8973 40.9181C16.191 40.4749 15.6353 39.8448 15.2301 39.0277C14.8251 38.2106 14.6226 37.2411 14.6226 36.1193C14.6226 34.9975 14.8251 34.0281 15.2301 33.2109C15.6353 32.3938 16.191 31.7637 16.8973 31.3205C17.6036 30.8773 18.4104 30.6557 19.3175 30.6557C19.8542 30.6557 20.3579 30.7336 20.8288 30.8895C21.3032 31.0452 21.7307 31.2738 22.1116 31.575C22.4924 31.8727 22.811 32.2363 23.0672 32.6656C23.3235 33.0915 23.5 33.5779 23.5969 34.125Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2578 41.4375H36.9755V30.8011H40.4032C41.435 30.8011 42.3179 31.0141 43.0519 31.4399C43.7859 31.8624 44.3486 32.47 44.7398 33.2629C45.1311 34.0523 45.3267 34.9975 45.3267 36.0986C45.3267 37.2065 45.1293 38.1604 44.7346 38.9602C44.3399 39.7565 43.7652 40.3694 43.0104 40.7987C42.2556 41.2245 41.338 41.4375 40.2578 41.4375ZM38.2635 40.295H40.1747C41.0541 40.295 41.7829 40.1252 42.3612 39.7859C42.9394 39.4466 43.3705 38.9637 43.6544 38.3369C43.9383 37.7102 44.0802 36.9641 44.0802 36.0986C44.0802 35.2399 43.94 34.5007 43.6596 33.8809C43.3791 33.2577 42.9602 32.7799 42.4027 32.4475C41.8453 32.1116 41.1511 31.9437 40.3201 31.9437H38.2635V40.295Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_218",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_218",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryGridGreen);
export default __webpack_public_path__ + "static/media/memory-grid-green.68cc59a2b3d3e844b56b1614e13f8127.svg";
export { ForwardRef as ReactComponent };